const getDataFieldsAreaMapData = () => {
  return [
    {
      title: "Area",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      queryKey: "Filters",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
  ];
};

const getCustomizationAreaMapData = () => {
  return [
    // {
    //   title: "map",
    //   type: "range",
    //   minValue: 1,
    //   maxValue: 100,
    //   reduxKey: "map",
    //   itemInArray: false,
    // },
    // {
    //   title: "Projection",
    //   type: "SELECT_BOX",
    //   defaultValue: { label: "Globe", value: "globe" },
    //   options: [
    //     { label: "Globe", value: "globe" },
    //     { label: "EqualEarth", value: "equalEarth" },
    //     { label: "satellite", value: "satellite" },
    //   ],
    //   reduxKey: "projection",
    //   itemInArray: false,
    // },
    // {
    //   title: "IndiaStateBoundries",
    //   type: "checkbox",
    //   defaultValue: true,
    //   reduxKey: "isBoundryVisible",
    // },
    // {
    //   title: "showHighways",
    //   type: "checkbox",
    //   defaultValue: true,
    //   reduxKey: "showHighways",
    // },
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Color Formatting",
      type: "CONDITIONAL_FORMATTING",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "conditionalFormatting",
      itemInArray: true,
      defaultValue: [],
    },
  ];
};

export { getCustomizationAreaMapData, getDataFieldsAreaMapData };
